import React, { useState } from "react";

function Counter(props) {
  const { count, handlePlus, handleMinus } = props;
 
  return (
    <div className="counter" style={{userSelect:"none"}}>
      {count === 0 ? (
        <div className="text-center" onClick={handlePlus}>
          Add
        </div>
      ) : (
        <div className="flex items-center justify-between user">
          <span onClick={handleMinus} style={{userSelect:"none"}}>-</span>
          <span>{count}</span>
          <span onClick={handlePlus} style={{userSelect:"none"}}>+</span>
        </div>
      )}
    </div>
  );
}

export default Counter;
